/* Feb-2026 · Celebrate Chapter Finishes — fired whenever a writer finishes
 * drafting any chapter (not just Chapter 1). Style is a per-writer
 * preference set in the User Profile panel (`celebration_style`), mirrored
 * to localStorage on load/save so this can read it synchronously without
 * an API round-trip mid-generation. Defaults to 'confetti' for anyone who
 * hasn't picked a style yet. Respects prefers-reduced-motion for every
 * motion-based style and never blocks the UI.
 */
import confetti from 'canvas-confetti';

function getStyle() {
  try { return window.localStorage.getItem('pw_celebration_style') || 'confetti'; }
  catch { return 'confetti'; }
}

function reducedMotion() {
  try { return !!window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches; }
  catch { return false; }
}

function burstConfetti() {
  confetti({
    particleCount: 60,
    spread: 65,
    startVelocity: 32,
    scalar: 0.8,
    gravity: 1.1,
    ticks: 160,
    origin: { x: 0.5, y: 0.35 },
    colors: ['#b45309', '#9a3412', '#78350f', '#d4a017', '#f1e4c3'],
    disableForReducedMotion: true,
  });
}

function burstFireworks() {
  // Two staggered bursts from either side, higher velocity + a touch of
  // shimmer — reads as "fireworks" while staying on the same restrained
  // palette as the rest of the Scriptorium theme (no full-rainbow confetti).
  const shared = {
    spread: 80,
    startVelocity: 48,
    scalar: 0.9,
    gravity: 0.9,
    ticks: 200,
    colors: ['#d4a017', '#f1e4c3', '#9a3412', '#fbbf24'],
    disableForReducedMotion: true,
  };
  confetti({ ...shared, particleCount: 45, angle: 60, origin: { x: 0.2, y: 0.5 } });
  confetti({ ...shared, particleCount: 45, angle: 120, origin: { x: 0.8, y: 0.5 } });
  window.setTimeout(() => {
    confetti({ ...shared, particleCount: 55, angle: 90, origin: { x: 0.5, y: 0.4 } });
  }, 220);
}

export function celebrateChapterFinished() {
  try {
    const style = getStyle();
    if (style === 'none' || style === 'chime') return;   // chime: the normal
    // "Chapter N drafted" toast (already shown by the caller) IS the
    // chime — no confetti motion, and no second/duplicate toast here.
    if (reducedMotion()) return;
    if (style === 'fireworks') burstFireworks();
    else burstConfetti();
  } catch { /* delight-only feature — never let it break drafting */ }
}
